module.exports = __webpack_public_path__ + "media/images/checkbox-c9e7eb0eecd8ad0f0a9ddc2493f5ecfa.svg";